import { QueryClient, QueryClientProvider } from 'react-query';
import { Routes, Route } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Root from 'src/routes/root';
import ErrorPage from 'src/routes/error-page';
import Login from 'src/routes/login';
import Transaction from 'src/routes/transaction';
import ApplicationPromoSent from 'src/routes/application-promo-sent';
import Index from 'src/routes';
import NotFoundPage from 'src/routes/not-found-page';
import { AuthInject } from 'src/auth/authInject';
import { SessionGate } from 'src/auth/sessionGate';
import { PageLoader } from 'src/components/PageLoader';
import AuthGuard from 'src/auth/authGuard';
import { Permissions } from 'src/auth/permissions/constants';
import Promotions from 'src/routes/promotions';
import NewDebitInfo from 'src/components/NewDebitInfo';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, cacheTime: 3000, retry: 1 } }
});

const App = () => {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <SessionGate>
      <QueryClientProvider client={queryClient}>
        <AuthInject />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/promotions" element={<Promotions />}>
            <Route
              path="application-promo-sent"
              element={
                <AuthGuard
                  component={ApplicationPromoSent}
                  permission={Permissions.PermissionsList.ReadStatusService}
                />
              }
            />
          </Route>
          <Route element={<Root />} errorElement={<ErrorPage />}>
            <Route path="/" element={<Index />} />
            <Route
              path="/transactions"
              element={
                <AuthGuard
                  component={Transaction}
                  anyPermissions={[
                    Permissions.PermissionsList.ReadTransactions,
                    Permissions.PermissionsList.DownloadTransactions,
                    Permissions.PermissionsList.ManageTransactions
                  ]}
                />
              }
            />
            <Route path="/new-debit-info" element={<NewDebitInfo />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </QueryClientProvider>
    </SessionGate>
  );
};

export default App;
